<template>
    <cartApp></cartApp>
</template>

<script>
import cartApp from '@/components/cart/cartApp.vue';
export default {
    name:'cart',
    components:{cartApp},
    data:function(){
        return{}
    },
     mounted(){
         document.body.classList.add('CartClass');
    },
    destroyed(){
      document.body.classList.remove('CartClass');
    }
}
</script>